module.exports = __webpack_public_path__ + "static/media/PAVER_MENU-normal.dbbd2ce7.png";